import { defineStore } from "pinia";

interface State {
  premadeTemplates: boolean;
  hideSearch?: boolean;
  showDelete?: boolean;
  selectedCategories: number[];
  selectedKeywords: number[];
  query: string;
}

export const usePremadeTemplatesStore = defineStore("premadeTemplates", {
  state: (): State => ({
    premadeTemplates: false,
    selectedCategories: [],
    selectedKeywords: [],
    query: "",
  }),

  actions: {
    setPremadeTemplates(val: boolean) {
      this.premadeTemplates = val;
    },
    setPremadeTemplatesOptions(options: {
      hideSearch?: boolean;
      showDelete?: boolean;
    }) {
      this.hideSearch = options.hideSearch;
      this.showDelete = options.showDelete;
    },
  },
});
